import './contentModalEligibiliteContrat.css';
import { MtxButton } from '@meilleurtaux/mtp-uikit-react';

interface ContentModalEligibiliteContratProp {
  modal: string;
  openModal: () => void;
  cancelablePeriod?: number | null;
}

export const ContentModalEligibiliteContrat = ({
  modal,
  openModal,
  cancelablePeriod,
}: ContentModalEligibiliteContratProp) => {
  switch (modal) {
    case 'modalPLAOWN':
      return (
        <p>
          Le versement n’est pas disponible car vous avez le statut de co-titulaire sur ce contrat. En attendant,
          rendez-vous sur votre espace gestionnaire Spirica.
        </p>
      );

    case 'modalRENSPC':
      return (
        <p>
          Le versement sera disponible après l&apos;expiration de la période de renonciation de votre contrat (
          {cancelablePeriod ?? 30} jours après la signature).
        </p>
      );

    case 'modalPRESPC':
      return <p>Connectez-vous sur votre espace gestionnaire Spirica pour ajouter un compte de prélèvement.</p>;

    case 'modalCAPJUR':
      return (
        <div className="eligible-contrat-modale">
          <h2>Vous ne pouvez pas réaliser un versement</h2>
          <p>
            Vous ne pouvez pas réaliser de versement car vous n’avez pas le statut de Majeur capable. Prenez contact
            avec votre conseiller.
          </p>

          <MtxButton
            className="modal-eligibilite-btn tchatclose2"
            onClick={() => openModal()}
            variant="primary"
            size="medium"
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>

          <MtxButton
            className="modal-eligibilite-btn tchatopen2"
            style={{ display: 'none' }}
            variant="primary"
            size="medium"
            onClick={() => {}}
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>
        </div>
      );

    case 'modalGPOUT':
      return (
        <div className="eligible-contrat-modale">
          <h2>Le versement n’est pas disponible</h2>
          <p>
            Les gestions pilotée AAA et Amiral ne sont plus disponibles au versement. Prenez contact avec votre
            conseiller pour connaître nos nouvelles opportunités.
          </p>

          <MtxButton
            className=" modal-eligibilite-btn tchatclose4"
            onClick={() => openModal()}
            variant="primary"
            size="medium"
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>

          <MtxButton
            className=" modal-eligibilite-btn tchatopen4"
            style={{ display: 'none' }}
            variant="primary"
            size="medium"
            onClick={() => {}}
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>
        </div>
      );

    case 'modalAVNENC':
      return (
        <div className="eligible-contrat-modale">
          <h2>Vous ne pouvez pas effectuer de versement</h2>
          <p>
            Vous ne pouvez pas effectuer de versement car une avance est en cours sur votre contrat. Prenez contact avec
            votre conseiller.
          </p>

          <MtxButton
            className="modal-eligibilite-btn tchatclose3"
            onClick={() => openModal()}
            variant="primary"
            size="medium"
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>

          <MtxButton
            className=" modal-eligibilite-btn tchatopen3"
            style={{ display: 'none' }}
            variant="primary"
            size="medium"
            onClick={() => {}}
          >
            <div>Contacter mon conseiller</div>
          </MtxButton>
        </div>
      );

    default:
      break;
  }
};
